export function segmentErrorMessage(status, detail, fallbackPrefix = "Erreur", context = null) {
    const raw = typeof detail === "string" ? detail : (detail ? JSON.stringify(detail) : "");
    const text = raw.toLowerCase();

    if (status === 400) {
        if (context === "refresh" || text.includes("refresh")) {
            if (text.includes("unomi") || text.includes("recompute")) {
                return "Impossible de recalculer ce segment depuis l’admin : en mode Unomi / CDP only, les membres sont évalués dans le CDP. Le backend doit synchroniser la liste (voir SEGMENTS_FRONTEND.md).";
            }
            if (text.includes("dynamic") && text.includes("member")) {
                return "Le recalcul des membres n’est pas disponible pour ce segment dynamique Unomi / CDP.";
            }
        }
        if (text.includes("dynamic") && text.includes("member")) {
            if (context === "add" || context === "remove") {
                return "Ce segment est dynamique : la gestion manuelle des membres est interdite.";
            }
            return raw
                ? `Requête refusée : ${raw}`
                : "Ce segment est dynamique : la gestion manuelle des membres est interdite.";
        }
        if (text.includes("recompute") && text.includes("static")) {
            return "Le recalcul ne s’applique qu’aux segments dynamiques.";
        }
        if (text.includes("recompute") && (text.includes("unomi") || text.includes("provider"))) {
            return "Le recalcul moteur (recompute / refresh) n’est pas supporté pour ce segment Unomi. Utiliser la synchro membership depuis le CDP côté backend.";
        }
        if (text.includes("condition") && text.includes("static")) {
            return "Un segment statique ne peut pas contenir de conditions.";
        }
        return `${fallbackPrefix}: requête invalide (400).`;
    }

    if (status === 409) {
        if (text.includes("already") || text.includes("déjà") || text.includes("deja")) {
            return "Conflit (409) : le membre est déjà présent dans ce segment.";
        }
        if (text.includes("referenc") || text.includes("rule") || text.includes("job")) {
            return "Conflit (409) : ce segment est encore référencé par des règles/jobs.";
        }
        return "Conflit (409) : vérifiez les références et réessayez.";
    }

    if (status === 502) {
        return "Erreur CDP Unomi (502) : synchronisation impossible. Réessayez ou utilisez 'Resync Unomi'.";
    }

    return detail || `${fallbackPrefix} (HTTP ${status || "inconnu"})`;
}

export default segmentErrorMessage;
